import script from "./HumanHandoverComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./HumanHandoverComponent.vue?vue&type=script&lang=ts&setup=true"

import "./HumanHandoverComponent.vue?vue&type=style&index=0&id=a811e772&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a811e772"]])

export default __exports__